import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Smartphone, Share, X } from "lucide-react";

const KEY = "shi_install_dismissed";
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export function InstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (isStandalone() || localStorage.getItem(KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIos()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);
  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  const install = async () => { if (!prompt) return; prompt.prompt(); const { outcome } = await prompt.userChoice; if (outcome === "accepted") setShow(false); setPrompt(null); };
  if (!show) return null;
  return (
    <div className="lg:hidden flex items-center gap-3 px-3 py-2 bg-blue-700 text-white text-sm" data-testid="install-banner">
      <img src="/icon-192.png" alt="" className="h-9 w-9 rounded-lg shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold leading-tight">Add Safer Highways to your home screen</div>
        {prompt ? <div className="text-xs text-blue-100">Opens full-screen like an app — one tap to scan cards and check alerts.</div>
          : <div className="text-xs text-blue-100 flex items-center gap-1 flex-wrap">Tap <Share className="h-3.5 w-3.5 inline" /> <b>Share</b> then <b>Add to Home Screen</b>.</div>}
      </div>
      {prompt && <Button size="sm" variant="secondary" className="h-8 shrink-0" onClick={install} data-testid="install-app-button"><Smartphone className="h-4 w-4 mr-1" />Install</Button>}
      <button type="button" onClick={dismiss} className="p-1 rounded hover:bg-white/10 shrink-0" aria-label="Dismiss" data-testid="install-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}
